//github.com/gosimple/slug - JS version of the go slugification

const charMap: { [key: string]: string } = {
  ø: 'o',
  æ: 'ae',
  œ: 'oe',
  ß: 'ss',
  þ: 'th',
};

export const slugify = (str: string) => {
  if (!str || typeof str !== 'string') {
    return '';
  }

  return [...str]
    .map((char) => charMap[char] || char)
    .join('')
    .normalize('NFKD') // Decompose accented characters (e.g., é → e +  ́)
    .replace(/[\u0300-\u036F]/g, '') // Remove diacritics
    .toLowerCase()
    .replace(/&/g, 'and') // Convert & to 'and' - only substitution in Go library
    .replace(/[^\da-z]+/g, '-') // Replace non-alphanumeric characters with hyphen
    .replace(/^-+|-+$/g, '') // Trim leading/trailing hyphens
    .replace(/-{2,}/g, '-'); // Collapse multiple hyphens
};
